import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private showModalSubject$ = new Subject<MessageData>();
  showModal$ = this.showModalSubject$.asObservable();

  showSuccess(message: MessageContent): void {
    this.showModalSubject$.next({ type: 'success', message });
  }

  showWarning(message: MessageContent): void {
    this.showModalSubject$.next({ type: 'warning', message });
  }

  showError(message: MessageContent): void {
    this.showModalSubject$.next({ type: 'error', message });
  }
}

export interface MessageData {
  message: MessageContent;
  type: 'success' | 'warning' | 'error';
}

export interface MessageContent {
  title: string;
  text?: string;
  buttons?: MessageButtonContent[];
}

export interface MessageButtonContent {
  label: string;
  actionFn?: () => void;
  type: 'cancel' | 'confirm';
}
